import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { LoadingExperience } from './LoadingExperience';

// Define the error shape we expect from Apollo Client
interface GraphQLErrorLike {
  message: string;
  graphQLErrors?: Array<{ extensions?: { code?: string } }>;
}

export const QueryResult = ({
  loading,
  error,
  data,
  children,
}: {
  loading: boolean;
  error: unknown;
  data: unknown;
  children: ReactNode;
}) => {
  if (error) {
    const graphQLError = error as GraphQLErrorLike;
    graphQLError.graphQLErrors?.forEach(gqlError => {
      if (gqlError.extensions?.code === 'UNAUTHENTICATED') {
        localStorage.removeItem('loginToken');
        window.location.reload();
      }
    });
    return (
      <Flex align='center' justify='center' py={12} px={4} w='100%'>
        <Box
          maxW='520px'
          w='100%'
          p={6}
          borderRadius='2xl'
          bg='rgba(127, 29, 29, 0.22)'
          border='1px solid rgba(248, 113, 113, 0.35)'
          backdropFilter='blur(16px)'
          boxShadow='0 16px 40px rgba(0, 0, 0, 0.4)'
        >
          <VStack align='start' gap={2}>
            <Heading size='md' color='red.300'>
              ⚠️ Telemetry Interference
            </Heading>
            <Text fontSize='sm' color='red.100'>
              {graphQLError.message}
            </Text>
          </VStack>
        </Box>
      </Flex>
    );
  }
  if (loading) {
    return <LoadingExperience />;
  }
  if (data) {
    return <>{children}</>;
  }
  return (
    <Flex align='center' justify='center' py={12} px={4} w='100%'>
      <Box
        maxW='420px'
        w='100%'
        p={6}
        borderRadius='2xl'
        bg='rgba(255, 255, 255, 0.04)'
        border='1px solid rgba(255, 255, 255, 0.08)'
        textAlign='center'
      >
        <Text fontSize='lg' fontWeight='600' color='gray.300'>
          No results found in the squirrel archives 🐿️
        </Text>
      </Box>
    </Flex>
  );
};
